export class RuntimeConfigValue {
  private readonly _key: string;
  private readonly _resolve: () => string | null;

  constructor(key: string, resolve: () => string | null) {
    this._key = key;
    this._resolve = resolve;
  }

  asString(): string {
    const value = this._resolve();
    if (value === null) {
      throw new Error(
        `Value for ${this._key} is not present as build time, runtime or default variable`,
      );
    }
    return value;
  }

  Or(defaultValue: string): string {
    return this._resolve() ?? defaultValue;
  }
}
